export const HOME = '/';
export const SIGN_UP = '/Signup';
export const SIGN_IN = '/Signin';
export const PASSWORD_FORGET = '/Pw-forget';
export const ACCOUNT = '/Account';
export const ACCOUNT_SHARE = '/Account/Share';
export const ACCOUNT_VISITORS = '/Account/Visitors';
export const USER = '/User';
export const INVESTOR = '/Investor';
export const BANKER = '/Banker';
export const ADMIN = '/Admin';
export const ADMIN_ADD_MINT = '/Admin/AddMint';
export const ADMIN_COIN_PRICING = '/Admin/CoinPricing';
export const ADMIN_MONARCH_PRICING = '/Admin/MonarchPricing';
export const ADMIN_EDIT_USER = '/Admin/:id/Edit';
export const ADMIN_DETAILS = '/Admin/:id';
export const PRIVACY = '/Privacy';
export const TERMS = '/Terms';
export const DASHBOARD = '/Dashboard';
export const COINS = '/Coins';
export const COINS_ADD = '/Coins/Add/';
export const COINS_PURCHASE = '/Coins/Purchase/';
export const COINS_CREATE = '/Coins/Create/';
export const COINS_EDIT = '/Coins/Edit/';
export const COINS_CASE = '/Coins/Case';
export const COINS_CASE_LIST = '/Coins/Case?product=:productId';
export const COINS_CASE_DETAILS = '/Coins/Case/:id';
export const COINS_CASE_ADD = '/Coins/Add/:id';
export const COINS_CASE_PURCHASE = '/Coins/Purchase/:id';
export const COINS_CASE_PURCHASE_SUCCESS = '/Coins/Purchase/:id/success';
export const COINS_CASE_EDIT = '/Coins/Edit/:id';
export const COINS_CASE_TRANSFER = '/Coins/Transfer/:id';
